import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const VersionHistoryItemSkeleton = ({ index }) => (
    <Styled.VersionHistoryItemListItem isSelected={index === 0}>
        {index === 0 && <Styled.VersionHistoryItemSkeletonText alpha={0.35 - (index + 1) * 0.04}>________</Styled.VersionHistoryItemSkeletonText>}
        <Styled.VersionHistoryItemSkeletonText alpha={0.35 - (index + 1) * 0.05}>_________________</Styled.VersionHistoryItemSkeletonText>
        <Styled.VersionHistoryItemSkeletonText alpha={0.35 - (index + 1) * 0.06}>___________</Styled.VersionHistoryItemSkeletonText>
    </Styled.VersionHistoryItemListItem>
);

VersionHistoryItemSkeleton.propTypes = {
    index: PropTypes.number.isRequired,
};

export default VersionHistoryItemSkeleton;
